import { Box, Typography, Container } from '@mui/material';

interface LandingPageAboutProps {
  bio: string;
  primaryColor: string;
}

export const LandingPageAbout = ({ bio, primaryColor }: LandingPageAboutProps) => {
  if (!bio) return null;

  return (
    <Box
      component="section"
      id="about"
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: 'white',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 700,
            mb: 3,
            textAlign: 'center',
            color: 'grey.900',
          }}
        >
          About Me
        </Typography>

        <Box
          sx={{
            position: 'relative',
            pl: { xs: 0, md: 4 },
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: 4,
              bgcolor: primaryColor,
              borderRadius: 2,
              display: { xs: 'none', md: 'block' },
            },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: 'grey.700',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              whiteSpace: 'pre-wrap',
            }}
          >
            {bio}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
